import i18n from "../i18n";

// Okunur adlar seçili dile göre gelir. Değerler okunurken çevrildiği için bu nesneler dil değişince de güncel kalır;
// bilinmeyen alan olduğu gibi gösterilir (yeni bir edge kontrolü eklenince arayüz güncellenmeden de görünür kalır).
export function translatedLabels(prefix, keys) {
  const labels = {};
  keys.forEach((key) => Object.defineProperty(labels, key, { enumerable: true, get: () => i18n.t(`alarms.${prefix}.${key}`) }));
  return labels;
}

const FIELD_LABELS = translatedLabels("field", [
  "device_session_flapping", "stack_restart", "device_reboot", "metrics_stale", "cloud_replay_backlog",
  "usb_net_reenumerate", "usb_net_reenumerate_failed", "usb_wifi_flap_reenumerate", "device_no_data",
  "edge_offline", "vpn_down", "ota_install_failed", "ota_rolled_back",
]);

export function alarmFieldLabel(field) {
  if (!field) return "-";
  const base = String(field).split(":")[0];
  return FIELD_LABELS[base] ?? field;
}

export const FAILURE_DOMAIN_LABELS = translatedLabels("domain", [
  "acquisition", "protocol_session", "data_processing", "storage", "cloud_transport", "network", "vpn",
  "system_resources", "time_integrity", "power_hardware", "software_update", "unknown",
]);

export const DIAGNOSIS_STATUS_LABELS = translatedLabels("diagnosis", ["pending", "skipped_no_key", "done", "failed", "rate_limited"]);
